import React from "react";
import Form from "react-bootstrap/Form";

const toggleDmrOption = (optionValue, selectedOptions, setFieldValue) => {
  const nextOptions = [...selectedOptions];

  if (nextOptions.includes(optionValue)) {
    nextOptions.splice(nextOptions.indexOf(optionValue), 1);
  } else {
    nextOptions.push(optionValue);
  }

  setFieldValue("dmrOptions", nextOptions);
};

const DmrDispositionFields = ({
  formValues,
  setFieldValue,
  dispositionFieldsConfig,
  disableActions,
}) => {
  const checkboxes = dispositionFieldsConfig?.checkboxes || [];
  const groupLabel = dispositionFieldsConfig?.label || "Disposition";

  return (
    <Form.Group>
      <Form.Label>{groupLabel}</Form.Label>
      {checkboxes.map((checkbox) => (
        <Form.Check
          key={checkbox.name}
          id={`faxdisposition-form-dmr-${checkbox.name}`}
          type="checkbox"
          label={
            <span className="fw-semibold small">{checkbox.label}</span>
          }
          value={checkbox.value}
          checked={(formValues.dmrOptions ?? []).includes(checkbox.value)}
          disabled={disableActions}
          onChange={() =>
            toggleDmrOption(
              checkbox.value,
              formValues.dmrOptions ?? [],
              setFieldValue
            )
          }
        />
      ))}
    </Form.Group>
  );
};

export default DmrDispositionFields;
